import * as keys from '../actions/alerts';

class Alert
{
	constructor(message, type = 'danger', timeout = 10) {
		this.message = message;
		this.type = type;
		this.timeout = timeout;

		this.id = Math.random();
	}
}

const state = {
	alerts: []
}

const getters = {}

const mutations = {
	[keys.ALERT_APPEND]: (state, alert) => {
		state.alerts.push(alert);
	},

	[keys.ALERT_REMOVE]: (state, index) => {
		state.alerts.splice(index, 1);
	}
}

const actions = {
	[keys.ALERT_APPEND]: ({ commit }, message, type = 'danger', timeout = 20) => {
		commit(keys.ALERT_APPEND, new Alert(message, type, timeout));
	},

	[keys.ALERT_REMOVE]: ({ commit }, index) => {
		commit(keys.ALERT_REMOVE, index);
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
